import { debounce } from 'lodash';
import api from '@/services/api';

import translations from '@/mixins/translations';
import helpers from '../services/helpers';
import axios from 'axios';

const pager = {
  mixins: [translations],
  data() {
    return {
      selected: [],
      bulkAction: 'bulkAction',
      bulkActions: [{ title: 'Delete', value: 'delete' }],
      searchField:
        this.$route.query?.search || this.$route.query?.quickSearch || '',
      pageSizeList: [10, 20, 50, 100],
      // how much items in pagination will be shown before and after current page
      numberOfPages: 3,
      actionName: '',
      deleteActionName: '',
      bulkActionName: '',
      exportActionName: '',
      searchConfig: {
        sortBy: 'createdDate',
        isSortAscending: false,
        pageSize:
          this.pageSize || localStorage.getItem('pageSize')
            ? parseInt(localStorage.getItem('pageSize'), 10)
            : 10,
        quickSearch:
          this.$route.query?.search || this.$route.query?.quickSearch || '',
        page: 1,
        cancelTokenSource: null,
      },
    };
  },
  computed: {
    pager() {
      return this.$store.getters.getPager;
    },
    pages() {
      const { currentPage, totalPages } = this.pager;
      const { numberOfPages } = this;

      const min =
        currentPage - numberOfPages >= 1 ? currentPage - numberOfPages : 1;
      const max =
        currentPage + numberOfPages <= totalPages
          ? currentPage + numberOfPages
          : totalPages;

      return helpers.generateRange(min, max);
    },
    toResults() {
      return this.pager.totalItems <
        this.pager.currentPage * this.searchConfig.pageSize
        ? this.pager.totalItems
        : this.pager.currentPage * this.searchConfig.pageSize;
    },
    fromResults() {
      return (this.pager.currentPage - 1) * this.searchConfig.pageSize == 0
        ? 1
        : (this.pager.currentPage - 1) * this.searchConfig.pageSize + 1;
    },
    nextDisabled() {
      return this.pager.page === this.pager.totalPages;
    },
    prevDisabled() {
      return this.pager.page === 1;
    },
    selectAll: {
      get: function () {
        // List must be defined in upper component
        return this.selected.length == this.list.length;
      },
      set: function (value) {
        const selected = [];

        if (value) {
          this.list.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.selected = selected;
      },
    },
  },
  methods: {
    goToPage(number) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.searchConfig.pageSize = localStorage.getItem('pageSize')
        ? parseInt(localStorage.getItem('pageSize'), 10)
        : 10;
      if (
        number === this.pager.currentPage ||
        number > this.pager.totalPages ||
        number < 1
      )
        return;

      this.searchConfig.page = number;
      this.searchConfig.quickSearch = this.$route.query?.search || this.$route.query?.quickSearch || '',

      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
      });
    },
    firstLoad() {
      const { query } = this.$route;
      // Same as go to page 1, but without animation
      this.searchConfig.pageSize = localStorage.getItem('pageSize')
        ? parseInt(localStorage.getItem('pageSize'), 10)
        : 10;

      (this.searchConfig.page = query?.page ? parseInt(query.page, 10) : 1),
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
        });
    },
    handleSort(field) {
      if (this.searchConfig.sortBy === field) {
        this.searchConfig.isSortAscending = !this.searchConfig.isSortAscending;
      } else {
        this.searchConfig.sortBy = field;
        this.searchConfig.isSortAscending = false;
      }
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
      });
    },
    isSortAsc(field) {
      return (
        this.searchConfig.isSortAscending && this.searchConfig.sortBy === field
      );
    },
    isSortDesc(field) {
      return (
        !this.searchConfig.isSortAscending && this.searchConfig.sortBy === field
      );
    },
    changePageSize(pageSize) {
      this.searchConfig.pageSize = pageSize;
      this.pageSize = pageSize;
      localStorage.setItem('pageSize', pageSize);
      this.searchConfig.page = 1;
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
      });
    },
    resetFilters() {
      // Reset filters
      this.searchField = '';
      this.searchConfig = {
        sortBy: 'createdDate',
        isSortAscending: false,
        pageSize: 10,
        quickSearch: '',
        page: 1,
      };

      this.$router.push({ query: { page: 1, ...this.paginationProps } });

      // Remove items from localStorage
      localStorage.removeItem('pageSize');

      // Update data in component
      this.$store.dispatch(this.actionName, this.searchConfig);
    },
    debounceInput: debounce(function () {
      this.searchConfig.quickSearch = this.searchField.trim();

      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Operation canceled due to new request.');
      }

      this.cancelTokenSource = axios.CancelToken.source();

      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        quickSearch: this.searchConfig.quickSearch,
        cancelToken: this.cancelTokenSource.token,
      });

      this.$router.push({
        query: {
          page: 1,
          search: this.searchConfig.quickSearch,
          ...this.paginationProps,
        },
      });
    }, 300),
    handleBulkAction(exportSource) {
      switch (this.bulkAction) {
        case 'delete':
          if (this.selected.length === 0) {
            this.$toast.error(this.translations.noItemSelected);
            return;
          }
          this.deleteSelected();
          this.bulkAction = 'bulkAction';
          break;
          case 'bulkAction':
            if (this.selected.length === 0) {
              this.$toast.error(this.translations.noItemSelected);
              return;
            }
            this.bulkActionSelected();
            this.bulkAction = 'bulkAction';
            break;
          case 'export':
            this.bulkExportSelected(exportSource);
            this.bulkAction = 'bulkAction';
            break;
        default:
          this.$toast.error(this.translations.selectAction);
      }
    },
    deleteSelected() {
      api[this.deleteActionName](this.selected).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
        });
      }).catch((err) => {
        this.$toast.error(err?.response?.data?.info || 'Desila se greška');
      });
    },
    bulkActionSelected() {
      api[this.bulkActionName](this.selected).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
        });
      }).catch((err) => {
        this.$toast.error(err?.response?.data?.info || 'Desila se greška');
      });
    },
    bulkExportSelected(exportSource) {
      if (exportSource === 'orders') {
        api.bulkExportOrder(this.selected).then((response) => {
          if (response.data.status === 0) {
            this.exportFile(response.data.data);
          }
          this.$toast.info(response.data.info);
          this.$store.dispatch(this.actionName, {
            ...this.searchConfig,
            ...this.paginationProps,
          });
        });
      } else if (exportSource === 'newsletters') {
        api.exportNewsletters().then((response) => {
          console.log(response);
          
          const contentDisposition = response.headers['content-disposition'];
          const fileName = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : 'Newsletters_Export.xlsx';

        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 100);
      });
    }
    },
    exportFile(data) {
      // Sample data you are receiving from the backend
      const fileData = {
        fileContents: data.fileContents,
        contentType: data.contentType,
        fileDownloadName: data.fileDownloadName,
      };
      
      // Decode the Base64-encoded file content
      const byteCharacters = atob(fileData.fileContents);

      // Convert the byte characters into an array of byte numbers
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Convert the array of byte numbers into a typed array (Uint8Array)
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob from the byte array with the correct content type
      const blob = new Blob([byteArray], { type: fileData.contentType });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create an anchor element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileData.fileDownloadName;

      // Append the anchor to the document, trigger the download, and then remove the anchor
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Revoke the object URL after a short delay to release memory
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 100);

      // Optionally, if you want to handle tab or popup opening (but not necessary here)
      // const newTab = window.open(url, '_blank');
      // newTab.close();
    },
  },
  watch: {
    list() {
      this.selected = [];
    },
  },
};

export default pager;
